const postShopeeCallbackPayload = (params) => {
  const code = params.get('code');
  const state = params.get('state');

  const accountLivestreamId = localStorage.getItem('accountLivestreamId');

  let payload = { code };

  if (state) payload = { ...payload, state };
  else payload = { ...payload, accountLivestreamId };

  return payload;
};

export default postShopeeCallbackPayload;
